﻿import React from 'react';

import { GMetrixStackedProgressBar, GMetrixStackedProgressBarItem } from 'components/GMetrixStackedProgressBar/GMetrixStackedProgressBar';
import { ReportComponent, ResultItem } from 'apis/ReportApi';
import { Col, Container } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import 'pages/reports/components/ChartStackedProgressBar/styles/chart-stacked-progress-bar.scss';

interface ChartStackedProgressBarProps {
	component: ReportComponent;
	generateFakeProgressBars: (countOfProgressBars: number) => JSX.Element[];
	index: number;
	isSubReport?: boolean;
	loading: boolean;
}

export function ChartStackedProgressBar({
    component,
    generateFakeProgressBars,
    index,
    isSubReport = false,
    loading
}: ChartStackedProgressBarProps) {

    const formatData = (data: ResultItem[], convertToPercentage: boolean, percentageNum: number) => {

        const formattedData: GMetrixStackedProgressBarItem[] = [];
        data.map(dataItem => {

            if (convertToPercentage) {

                dataItem.Share = String(
                    ((Number(dataItem.Share) / percentageNum) * 100).toFixed(2)
                );

            }
            formattedData.push({ color: dataItem.Color, title: dataItem.Title, value: Number(dataItem.Share) });

        });
        return formattedData;

    };

    return (
        <Col
            className="component-wrapper__col flex-column"
            key={`${component.ComponentId}-${index}`}
            lg={isSubReport ? 12 : component.WidthLg}
            md={isSubReport ? 12 : component.WidthMd}
            sm={isSubReport ? 12 : component.WidthSm}
            xl={isSubReport ? 12 : component.WidthXl}
            xxl={component.WidthXl}
        >
            {!loading ? (
                <Container className="chart-stacked-progress-bar mb-3">
                    <h6 className="text-center chart-stacked-progress-bar__title">
                        {component.Title}
                    </h6>
                    {component.Results?.SeriesList.length === 0 && (
                    <div className="text-center">
                        <FormattedMessage defaultMessage="No Results Found" id="no_results_found.f1d71249" />
                    </div>
                    )}

                    {component.Results &&
						component.Results.SeriesList.map((dataItem, i) => {

						    let percentageNum = 0;
						    let convertToPercentage = false;
						    dataItem.Data.map(item => {

						        if (Number(item.Share) > 100) {

						            convertToPercentage = true;

						        }
						        percentageNum += Number(item.Share);

						    });
						    return (
    <div key={i}>
        <div className="ps-2 font-weight-bold ml-2 mt-2">
            {dataItem.Name}
        </div>
        <GMetrixStackedProgressBar data={formatData(dataItem.Data, convertToPercentage, percentageNum)}/>
    </div>
						    );

						})}
                </Container>
            ) : (
                <Container>
                    {generateFakeProgressBars(component.ResultsCount)}
                </Container>
            )}
        </Col>
    );

}
